import styled, { css } from "styled-components";
import { CheckIcon as BaseCheckIcon } from "lucide-react";
import Flex from "../Flex";
import { colorMixin } from "../../helpers";

export const ITEM_Y_PADDING = 12;
export const ITEM_X_PADDING = 14;
export const ITEM_GAP = 8;
export const ITEM_CHECK_ICON_SIZE = 24;

export const TriggerWrapper = styled.button`
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    cursor: pointer;
    background: transparent;
    border: none;
`;

export const List = styled(Flex)`
    list-style: "none";
    margin: 0;
    overflow: auto;
    padding: 0;
`;

export const CheckIcon = styled(BaseCheckIcon)`
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    stroke: ${colorMixin("primary-500")};
`;

export const SectionItemHeading = styled.span`
    padding: ${`${ITEM_Y_PADDING}px ${ITEM_X_PADDING}px`};
`;

type ListItemProps = {
    $isFocused: boolean;
    $isSelected: boolean;
    $isDisabled: boolean;
};

export const ListItem = styled(Flex)`
    cursor: pointer;
    outline: none;
    padding: ${`${ITEM_Y_PADDING}px ${
        ITEM_X_PADDING + ITEM_CHECK_ICON_SIZE + ITEM_GAP
    }px ${ITEM_Y_PADDING}px ${ITEM_X_PADDING}px`};
    position: relative;
    gap: ${ITEM_GAP}px;
    align-items: center;

    ${({ $isDisabled, $isFocused, $isSelected }: ListItemProps) => {
        if ($isDisabled) {
            return css`
                background: ${colorMixin("background-primary-50")};
            `;
        }

        if ($isFocused) {
            return css`
                background: ${colorMixin("surface-50")};
            `;
        }

        if ($isSelected) {
            return css`
                background: ${colorMixin("surface-50")};
            `;
        }

        return "";
    }}
`;
